// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectLanguageMenuPopover__Ndbrn {
  min-width: 16px;
  min-height: 16px;
  max-height: 300px;
  background: var(--context-menu-surface) !important;
  box-shadow: var(--basic-box-shadow) !important;
  width: 210px !important;
  padding: unset !important;
  filter: unset !important;
  border-radius: unset !important;
  opacity: 1 !important;
  text-align: left !important;
  overflow: auto;
}
.selectLanguageMenuPopover__Ndbrn::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.selectLanguageMenuPopover__Ndbrn::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.selectLanguageMenuPopover__Ndbrn::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.selectLanguageMenuPopover__Ndbrn::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.selectLanguageMenuPopoverItem__bIOqQ {
  cursor: pointer;
  text-align: left;
  border-bottom: 1px solid var(--context-menu-stroke);
  text-decoration: none;
  display: flex;
  align-items: center;
  padding: 10px;
  color: var(--inputs-filled-text);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0.11px;
  text-transform: none;
}
.selectLanguageMenuPopoverItem__bIOqQ:last-child {
  border: none;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ManageTranslations/components/SelectLanguageMenu/style.module.scss"],"names":[],"mappings":"AA0EA;EAEE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kDAAA;EACA,8CAAA;EACA,uBAAA;EACA,yBAAA;EACA,wBAAA;EACA,+BAAA;EACA,qBAAA;EACA,2BAAA;EACA,cAAA;AA1EF;AAaE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAXJ;AAcE;EACE,+BAAA;EACA,kBAAA;AAZJ;AAeE;EACE,8BAAA;EACA,kBAAA;AAbJ;AAgBE;EACE,gBAAA;EACA,kBAAA;AAdJ;;AA6DA;EACE,eAAA;EACA,gBAAA;EACA,mDAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,oBAAA;AA1DF;AA4DE;EACE,YAAA;AA1DJ","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.selectLanguageMenuPopover {\n  // importants below to overwrite react-tooltip styles\n  min-width: 16px;\n  min-height: 16px;\n  max-height: 300px;\n  background: var(--context-menu-surface) !important;\n  box-shadow: var(--basic-box-shadow) !important;\n  width: 210px !important;\n  padding: unset !important;\n  filter: unset !important;\n  border-radius: unset !important;\n  opacity: 1 !important;\n  text-align: left !important;\n  overflow: auto;\n  @include scrollBar;\n}\n\n.selectLanguageMenuPopoverItem {\n  cursor: pointer;\n  text-align: left;\n  border-bottom: 1px solid var(--context-menu-stroke);\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  color: var(--inputs-filled-text);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px;\n  letter-spacing: 0.11px;\n  text-transform: none;\n\n  &:last-child {\n    border: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectLanguageMenuPopover": `selectLanguageMenuPopover__Ndbrn`,
	"selectLanguageMenuPopoverItem": `selectLanguageMenuPopoverItem__bIOqQ`
};
module.exports = ___CSS_LOADER_EXPORT___;
